import { Navigate } from "react-router";
import React, { useContext } from "react";
import { AppContext } from "../../context/AppContext";
import {Outlet} from "react-router";
import {ImpersonateDestroy} from "../Impersonation";

export const ProtectedRoute = ({ children }) => {
  const {
    services: {
      serviceAuth
    }
  } = useContext(AppContext);

  if (!serviceAuth.isLoggedIn()) {
    ImpersonateDestroy();

    return <Navigate to="/login" />;
  }

  return children ? children : <Outlet />;
};
